(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  
  $( document ).ready(function() {  
  $('.imagescroll').slick({
    autoplay: true,
    arrows: false,
    slidesToShow: 2,
    variableWidth: true,
    autoplaySpeed: 5000

  });});


  } catch(e) { console.error(e); }
})();
})();
